import { IconProps } from './IconProps';

const PlusLiquidGlass = ({ className, style }: IconProps) => {
  return (
    <svg
      className={className}
      style={style}
      width="63"
      height="42"
      viewBox="0 23 63 42"
      fill="none"
    >
      <g filter="url(#filter0_i_2927_17477)">
        <rect
          y="27.8203"
          width="62.6564"
          height="32.0923"
          rx="16.0462"
          fill="url(#paint0_linear_2927_17477)"
          fill-opacity="0.02"
        />
      </g>
      <g filter="url(#filter1_i_2927_17477)">
        <rect
          width="62.6564"
          height="32.0923"
          rx="16.0462"
          transform="matrix(1 0 0 -1 0 59.9102)"
          fill="url(#paint1_linear_2927_17477)"
          fill-opacity="0.02"
        />
      </g>
      <g filter="url(#filter2_i_2927_17477)">
        <rect
          y="27.8203"
          width="62.6564"
          height="32.0923"
          rx="16.0462"
          fill="white"
          fill-opacity="0.01"
        />
      </g>
      <g filter="url(#filter3_i_2927_17477)">
        <mask id="path-4-inside-1_2927_17477" fill="white">
          <path d="M0 43.8665C0 35.0044 7.18411 27.8203 16.0462 27.8203H46.6102C55.4723 27.8203 62.6564 35.0044 62.6564 43.8665V43.8665C62.6564 52.7285 55.4723 59.9126 46.6103 59.9126H16.0462C7.18412 59.9126 0 52.7285 0 43.8665V43.8665Z" />
        </mask>
        <path
          d="M0 43.8665C0 34.6668 7.45779 27.209 16.6574 27.209H45.999C55.1986 27.209 62.6564 34.6668 62.6564 43.8665V43.8665C62.6564 35.342 55.4723 28.4316 46.6103 28.4316H16.0462C7.18411 28.4316 0 35.342 0 43.8665V43.8665ZM62.6564 59.9126H0H62.6564ZM0 59.9126V27.8203V59.9126ZM62.6564 27.8203V59.9126V27.8203Z"
          fill="url(#paint2_linear_2927_17477)"
          mask="url(#path-4-inside-1_2927_17477)"
        />
      </g>
      <g filter="url(#filter4_i_2927_17477)">
        <mask id="path-6-inside-2_2927_17477" fill="white">
          <path d="M0 43.864C0 52.726 7.18411 59.9102 16.0462 59.9102H46.6102C55.4723 59.9102 62.6564 52.726 62.6564 43.864V43.864C62.6564 35.002 55.4723 27.8178 46.6103 27.8178H16.0462C7.18412 27.8178 0 35.002 0 43.864V43.864Z" />
        </mask>
        <path
          d="M0 43.864C0 53.0636 7.45779 60.5214 16.6574 60.5214H45.999C55.1986 60.5214 62.6564 53.0636 62.6564 43.864V43.864C62.6564 52.3884 55.4723 59.2989 46.6103 59.2989H16.0462C7.18411 59.2989 0 52.3884 0 43.864V43.864ZM62.6564 27.8178H0H62.6564ZM0 27.8178V59.9102V27.8178ZM62.6564 59.9102V27.8178V59.9102Z"
          fill="url(#paint3_linear_2927_17477)"
          mask="url(#path-6-inside-2_2927_17477)"
        />
      </g>
      <path
        d="M46.9606 50.7421C45.9751 50.7421 45.1165 50.5876 44.3849 50.2785C43.6533 49.9634 43.0758 49.527 42.6526 48.9695C42.2294 48.4119 41.9875 47.7665 41.927 47.0332L41.918 46.915H43.9223L43.9314 47.015C43.9737 47.409 44.1279 47.7514 44.3939 48.0423C44.666 48.3332 45.0288 48.5604 45.4823 48.724C45.9418 48.8877 46.4648 48.9695 47.0513 48.9695C47.6015 48.9695 48.0913 48.8816 48.5206 48.7059C48.9499 48.5301 49.2854 48.2877 49.5273 47.9786C49.7752 47.6696 49.8991 47.315 49.8991 46.915V46.906C49.8991 46.403 49.7087 45.9848 49.3278 45.6515C48.9468 45.3182 48.3241 45.0576 47.4594 44.8697L46.0265 44.5697C44.7023 44.2849 43.7379 43.8334 43.1333 43.2152C42.5286 42.591 42.2263 41.7941 42.2263 40.8244V40.8154C42.2324 40.0578 42.4349 39.3912 42.834 38.8155C43.2391 38.2397 43.7984 37.7913 44.5118 37.4701C45.2253 37.1489 46.0446 36.9883 46.9697 36.9883C47.8948 36.9883 48.702 37.1489 49.3912 37.4701C50.0866 37.7852 50.6338 38.2155 51.0328 38.7609C51.4379 39.3063 51.6647 39.9215 51.713 40.6063L51.7221 40.7245H49.7359L49.7177 40.6063C49.6633 40.2487 49.5152 39.9306 49.2733 39.6518C49.0375 39.373 48.7201 39.1548 48.321 38.9973C47.928 38.8336 47.4685 38.7549 46.9425 38.7609C46.4346 38.7609 45.9811 38.8397 45.582 38.9973C45.183 39.1488 44.8656 39.37 44.6297 39.6609C44.4 39.9518 44.2851 40.3033 44.2851 40.7154V40.7245C44.2851 41.2093 44.4695 41.6153 44.8383 41.9426C45.2132 42.2638 45.8209 42.5153 46.6613 42.6971L48.0943 43.0152C49.0073 43.2092 49.748 43.4667 50.3163 43.7879C50.8847 44.1091 51.2989 44.5061 51.5589 44.9788C51.8249 45.4454 51.9579 46.003 51.9579 46.6514V46.6605C51.9579 47.4968 51.7523 48.221 51.3412 48.8331C50.9361 49.4392 50.3587 49.9088 49.6089 50.2422C48.8592 50.5755 47.9764 50.7421 46.9606 50.7421Z"
        fill="white"
      />
      <path
        d="M35.4502 50.7404C34.3558 50.7404 33.4126 50.5373 32.6205 50.1313C31.8284 49.7253 31.2178 49.1617 30.7885 48.4405C30.3592 47.7132 30.1445 46.8678 30.1445 45.9042V37.3047H32.1852V45.7497C32.1852 46.38 32.3121 46.9345 32.5661 47.4133C32.8261 47.892 33.1979 48.2647 33.6816 48.5314C34.1714 48.798 34.7609 48.9314 35.4502 48.9314C36.1455 48.9314 36.735 48.798 37.2187 48.5314C37.7025 48.2647 38.0713 47.892 38.3252 47.4133C38.5792 46.9345 38.7061 46.38 38.7061 45.7497V37.3047H40.7468V45.9042C40.7468 46.8678 40.5321 47.7132 40.1028 48.4405C39.6796 49.1617 39.0719 49.7253 38.2799 50.1313C37.4939 50.5373 36.5506 50.7404 35.4502 50.7404Z"
        fill="white"
      />
      <path
        d="M21.2734 50.4222V37.3047H23.305V48.6587H29.4451V50.4222H21.2734Z"
        fill="white"
      />
      <path
        d="M11.7111 45.9406V44.2316H15.2845C16.1672 44.2316 16.8505 44.0043 17.3342 43.5498C17.8239 43.0892 18.0688 42.4529 18.0688 41.6408V41.6226C18.0688 40.7984 17.8239 40.1591 17.3342 39.7046C16.8505 39.25 16.1672 39.0228 15.2845 39.0228H11.7111V37.3047H15.7924C16.651 37.3047 17.4037 37.4865 18.0507 37.8501C18.7037 38.2077 19.2146 38.7107 19.5834 39.3591C19.9523 40.0015 20.1367 40.75 20.1367 41.6045V41.6226C20.1367 42.4772 19.9523 43.2317 19.5834 43.8862C19.2146 44.5346 18.7037 45.0407 18.0507 45.4043C17.4037 45.7618 16.651 45.9406 15.7924 45.9406H11.7111ZM10.6953 50.4222V37.3047H12.7269V50.4222H10.6953Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_i_2927_17477"
          x="0"
          y="27.8203"
          width="62.6562"
          height="36.6784"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.58462" />
          <feGaussianBlur stdDeviation="4.58462" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2927_17477"
          />
        </filter>
        <filter
          id="filter1_i_2927_17477"
          x="0"
          y="23.2318"
          width="62.6562"
          height="36.6784"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4.58462" />
          <feGaussianBlur stdDeviation="4.58462" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2927_17477"
          />
        </filter>
        <filter
          id="filter2_i_2927_17477"
          x="0"
          y="27.8203"
          width="62.6562"
          height="32.0938"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.44513" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2927_17477"
          />
        </filter>
        <filter
          id="filter3_i_2927_17477"
          x="0"
          y="27.8203"
          width="62.6562"
          height="32.0938"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.44513" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2927_17477"
          />
        </filter>
        <filter
          id="filter4_i_2927_17477"
          x="0"
          y="27.8164"
          width="62.6562"
          height="32.0938"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.44513" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2927_17477"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2927_17477"
          x1="31.3282"
          y1="27.8203"
          x2="31.3282"
          y2="59.9126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2927_17477"
          x1="31.3282"
          y1="0"
          x2="31.3282"
          y2="32.0923"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2927_17477"
          x1="31.3282"
          y1="20.1793"
          x2="31.3282"
          y2="39.2819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C3C3C3" />
          <stop offset="1" stop-color="#F9F9F9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2927_17477"
          x1="31.3282"
          y1="66.023"
          x2="31.3282"
          y2="57.6178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C3C3C3" />
          <stop offset="1" stop-color="#F9F9F9" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlusLiquidGlass;
